module.exports = __webpack_public_path__ + "static/media/team-ribbon-back.29a47f0d.png";